module.exports = __webpack_public_path__ + "img/solve-a-past-exam_icon.aae06165.svg";